module.exports = __webpack_public_path__ + "static/media/getpaid.3634c672.png";